// extracted by mini-css-extract-plugin
export default {"text-part":"style_text-part__1lkHB","intro-header":"style_intro-header__-0Bs4","intro-p":"style_intro-p__1BKn8"};